module.exports = __webpack_public_path__ + "img/profile-pic-chilling.e557dbaa.jpg";